import React from "react";
import { useSwipeable } from "react-swipeable";
/*
useSwipeable hook from `react-swipeable to let you build custom slider and control it in multi tools used in react-swipeable sliders
*/

export default React.forwardRef(({ onIdxChanged, items, ...props }, ref) => {
  const [slideTotal, setSlideTotal] = React.useState(0);
  const [currentSlide, setCurrentSlide] = React.useState(-1);
  const [slides, setSlides] = React.useState([]);
  const handlers = useSwipeable({
    onSwipedLeft: () => slideRight(),
    onSwipedRight: () => slideLeft(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const slideRight = React.useCallback(() => {
    let preActiveSlide;
    let proActiveSlide;
    let currentSlideLoc = currentSlide;

    const activeClass = "slider-single active";
    const slide = [...slides];
    if (slideTotal > 1) {
      if (currentSlideLoc < slideTotal) {
        currentSlideLoc++;
      } else {
        currentSlideLoc = 0;
      }
      if (currentSlideLoc > 0) {
        preActiveSlide = slide[currentSlideLoc - 1];
      } else {
        preActiveSlide = slide[slideTotal];
      }
      const activeSlide = slide[currentSlideLoc];
      if (currentSlideLoc < slideTotal) {
        proActiveSlide = slide[currentSlideLoc + 1];
      } else {
        proActiveSlide = slide[0];
      }

      slide.forEach((slideItem, index) => {
        if (slideItem.class.includes("preactivegone")) {
          slideItem.class = "slider-single proactivegone";
        }
        if (slideItem.class.includes("preactive")) {
          slideItem.class = "slider-single preactivegone";
        }
      });

      preActiveSlide.class = "slider-single preactive";
      activeSlide.class = activeClass;
      proActiveSlide.class = "slider-single proactive";
      setSlides(slide);
      setCurrentSlide(currentSlideLoc);
    } else if (slide[0] && slide[0].class !== activeClass) {
      slide[0].class = activeClass;
      setSlides(slide);
      setCurrentSlide(0);
    }
  }, [currentSlide, slideTotal, slides]); // slide to the right 

  const slideLeft = React.useCallback(() => {
    if (slideTotal > 1) {
      let preActiveSlide;
      let proActiveSlide;
      let currentSlideLoc = currentSlide;
      const slide = [...slides];

      if (currentSlideLoc > 0) {
        currentSlideLoc--;
      } else {
        currentSlideLoc = slideTotal;
      }

      if (currentSlideLoc < slideTotal) {
        proActiveSlide = slide[currentSlideLoc + 1];
      } else {
        proActiveSlide = slide[0];
      }
      let activeSlide = slide[currentSlideLoc];
      if (currentSlideLoc > 0) {
        preActiveSlide = slide[currentSlideLoc - 1];
      } else {
        preActiveSlide = slide[slideTotal];
      }
      slide.forEach((slideItem, index) => {
        if (slideItem.class.includes("proactivegone")) {
          slideItem.class = "slider-single preactivegone";
        }
        if (slideItem.class.includes("proactive")) {
          slideItem.class = "slider-single proactivegone";
        }
      });
      preActiveSlide.class = "slider-single preactive";
      activeSlide.class = "slider-single active";
      proActiveSlide.class = "slider-single proactive";
      setSlides(slide);
      setCurrentSlide(currentSlideLoc);
    }
  }, [currentSlide, slideTotal, slides]); // slide to the left 

  const handleOnIdxChanged = React.useCallback(() => {
    onIdxChanged(currentSlide);
  }, [currentSlide, onIdxChanged]); // handle on index change

  const init = React.useCallback(() => {
    const slidesArray = [];
    [...items].forEach((slide) => {
      const slideObject = {
        class: "slider-single proactivegone",
        element: slide,
      };
      slidesArray.push(slideObject);
    });
    if (items.length === 2) {
      [...items].forEach((slide) => {
        const slideObject = {
          class: "slider-single proactivegone",
          element: slide,
        };
        slidesArray.push(slideObject);
      });
    }
    setSlides(slidesArray);
    setSlideTotal(slidesArray.length - 1);
  }, []); // on start

  React.useLayoutEffect(() => {
    init();
  }, [init]);

  React.useEffect(() => {
    handleOnIdxChanged();
  }, [currentSlide, handleOnIdxChanged]);

  React.useLayoutEffect(() => {
    if (currentSlide === -1) {
      slideRight();
    }
  }, [slides, currentSlide, slideRight]);

  React.useImperativeHandle(ref, () => ({
    currentSlide: currentSlide,
    prev() {
      slideLeft();
    },
    next() {
      slideRight();
    },
  })); // slider ref to set the right and left functions in the slider ref 

  return (
    <div className="slider-3d" {...handlers}>
      {slides && slides.length > 0 && (
        <div className="slider-container">
          <div className="slider-content">
            {slides.map((slider, index) => (
              <div
                className={`${slider.class} ${
                  props.dir === "rtl" ? " rtl" : ""
                }`}
                key={index}
              >
                <div className="slider-single-content">{slider.element}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});
